import {
    getMainCategoryRepo,
    getVideoListingRepo,
    getEntityTypeRepo,
    getMainCategoryDropDownDataRepo, getSubCategoryListRepo,
    getEntityNameListRepo,
    postVideoDataRepo,
    putVideoDataRepo,
    putVideoKeywordMappingRepo,
    getVideoDetailRepo,
    getVideoKeywordMappingRepo,
    getVideoTitleRepo
} from "../repositories/premium/video";
import { createSlice } from "@reduxjs/toolkit";
const videoSlice = createSlice({
    name: "videoReducer",
    initialState: {
        mainCategoryListLoading: null,
        mainCategoryListData: null,
        mainCategoryListError: null,
        videoListingLoading: null,
        videoListingData: null,
        videoListingError: null,
        entityTypeLoading: null,
        entityTypeData: null,
        entityTypeError: null,
        mainCategoryLoading: null,
        mainCategoryData: null,
        mainCategoryError: null,
        subCategoryListLoading: null,
        subCategoryListData: null,
        subCategoryListError: null,
        entityNameListLoading: null,
        entityNameListData: null,
        entityNameListError: null,
        putVideoKeywordMappingData: null,
        putVideoKeywordMappingError: null,
        postVideoData: null,
        postVideoDataError: null,
        putVideoData: null,
        putVideoDataError: null,
        
        videoTitleLoading: false,
        videoTitleData: null,
        videoTitleError: null,
    },
    reducers: {
        getMainCategoryListLoading(state, action) {
            return {
                ...state,
                mainCategoryListLoading: true,
            };
        },
        getMainCategoryListSuccess(state, action) {
            return {
                ...state,
                mainCategoryListLoading: false,
                mainCategoryListData: action.payload,
            };
        },
        getMainCategoryListFailure(state, action) {
            return {
                ...state,
                mainCategoryListLoading: false,
                mainCategoryListError: action.payload,
            };
        },
        getVideoListingLoading(state, action) {
            return {
                ...state,
                videoListingLoading: true,
            };
        },
        getVideoListingSuccess(state, action) {
            return {
                ...state,
                videoListingLoading: false,
                videoListingData: action.payload,
            };
        },
        getVideoListingFailure(state, action) {
            return {
                ...state,
                videoListingLoading: false,
                videoListingError: action.payload,
            };
        },
        getEntityTypeLoading(state, action) {
            return {
                ...state,
                entityTypeLoading: true,
            };
        },
        getEntityTypeSuccess(state, action) {
            return {
                ...state,
                entityTypeLoading: false,
                entityTypeData: action.payload,
            };
        },
        getEntityTypeFailure(state, action) {
            return {
                ...state,
                entityTypeLoading: false,
                entityTypeError: action.payload,
            };
        },
        clearEntityTypeResponse(state, action) {
            return {
                ...state,
                entityTypeLoading: false,
                entityTypeError: action.payload,
            };
        },
        getMainCategoryDropDownDataLoading(state, action) {
            return {
                ...state,
                mainCategoryLoading: true,
            };
        },
        getMainCategoryDropDownDataSuccess(state, action) {
            return {
                ...state,
                mainCategoryLoading: false,
                mainCategoryData: action.payload,
            };
        },
        getMainCategoryDropDownDataFailure(state, action) {
            return {
                ...state,
                mainCategoryLoading: false,
                mainCategoryError: action.payload,
            };
        },
        clearMainCategoryDropDownDataResponse(state, action) {
            return {
                ...state,
                mainCategoryLoading: false,
                mainCategoryError: action.payload,
            };
        },
        getSubCategoryListLoading(state, action) {
            return {
                ...state,
                subCategoryListLoading: true,
            };
        },
        getSubCategoryListSuccess(state, action) {
            return {
                ...state,
                subCategoryListLoading: false,
                subCategoryListData: action.payload,
            };
        },
        getSubCategoryListFailure(state, action) {
            return {
                ...state,
                subCategoryListLoading: false,
                subCategoryListError: action.payload,
            };
        },
        clearSubCategoryListResponse(state, action) {
            return {
                ...state,
                subCategoryListLoading: false,
                subCategoryListError: action.payload,
            };
        },
        getEntityNameListLoading(state, action) {
            return {
                ...state,
                entityNameListLoading: true,
            };
        },
        getEntityNameListSuccess(state, action) {
            return {
                ...state,
                entityNameListLoading: false,
                entityNameListData: action.payload,
            };
        },
        getEntityNameListFailure(state, action) {
            return {
                ...state,
                entityNameListLoading: false,
                entityNameListError: action.payload,
            };
        },
        clearEntityNameListResponse(state, action) {
            return {
                ...state,
                entityNameListLoading: false,
                entityNameListError: action.payload,
            };
        },
        postVideoDataSuccess(state, action) {
            return {
                ...state,
                postVideoData: action.payload,
            };
        },
        postVideoDataFailure(state, action) {
            return {
                ...state,
                postVideoDataError: action.payload,
            };
        },
        clearPostVideoDataResponse(state, action) {
            return {
                ...state,
                postVideoDataError: action.payload,
            };
        },
        putVideoDataSuccess(state, action) {
            return {
                ...state,
                putVideoData: action.payload,
            };
        },
        putVideoDataFailure(state, action) {
            return {
                ...state,
                putVideoDataError: action.payload,
            };
        },
        clearPutVideoDataResponse(state, action) {
            return {
                ...state,
                putVideoDataError: action.payload,
            };
        },
        putVideoKeywordMappingSuccess(state, action) {
            return {
                ...state,
                putVideoKeywordMappingData: action.payload,
            };
        },
        putVideoKeywordMappingFailure(state, action) {
            return {
                ...state,
                putVideoKeywordMappingError: action.payload,
            };
        },
        clearPutVideoKeywordMappingResponse(state, action) {
            return {
                ...state,
                putVideoKeywordMappingError: action.payload,
            };
        },
        getVideoDetailLoading(state, action) {
            return {
                ...state,
                videoDetailLoading: true,
            };
        },
        getVideoDetailSuccess(state, action) {
            return {
                ...state,
                videoDetailLoading: false,
                videoDetailData: action.payload,
            };
        },
        getVideoDetailFailure(state, action) {
            return {
                ...state,
                videoDetailLoading: false,
                videoDetailError: action.payload,
            };
        },
        clearVideoDetailResponse(state, action) {
            return {
                ...state,
                videoDetailLoading: false,
                videoDetailError: action.payload,
            };
        },
        getVideoKeywordMappingLoading(state, action) {
            return {
                ...state,
                videoKeywordMappingLoading: true,
            };
        },
        getVideoKeywordMappingSuccess(state, action) {
            return {
                ...state,
                videoKeywordMappingLoading: false,
                videoKeywordMappingData: action.payload,
            };
        },
        getVideoKeywordMappingFailure(state, action) {
            return {
                ...state,
                videoKeywordMappingLoading: false,
                videoKeywordMappingError: action.payload,
            };
        },
        clearVideoKeywordMappingResponse(state, action) {
            return {
                ...state,
                videoKeywordMappingLoading: false,
                videoKeywordMappingError: action.payload,
            };
        },
        clearAllVideogResponses(state, action) {
            return {
                ...state,
                postVideoData: null,
                postVideoDataError: null,
                putVideoData: null,
                putVideoDataError: null,
                putVideoKeywordMappingData: null,
                putVideoKeywordMappingError: null
            };
        },
        getVideoTitleLoading(state, action) {
            return {
                ...state,
                videoTitleLoading: true,
            };
        },
        getVideoTitleSuccess(state, action) {
            return {
                ...state,
                videoTitleLoading: false,
                videoTitleData: action.payload,
            };
        },
        getVideoTitleFailure(state, action) {
            return {
                ...state,
                videoTitleLoading: false,
                videoTitleError: action.payload,
            };
        },
    },
});

export const {
    getMainCategoryListLoading,
    getMainCategoryListSuccess,
    getMainCategoryListFailure,
    getVideoListingLoading,
    getVideoListingSuccess,
    getVideoListingFailure,
    getEntityTypeLoading,
    getEntityTypeSuccess,
    getEntityTypeFailure,
    clearEntityTypeResponse,
    getMainCategoryDropDownDataLoading,
    getMainCategoryDropDownDataSuccess,
    getMainCategoryDropDownDataFailure,
    clearMainCategoryDropDownDataResponse,
    getSubCategoryListLoading,
    getSubCategoryListSuccess,
    getSubCategoryListFailure,
    clearSubCategoryListResponse,
    getEntityNameListLoading,
    getEntityNameListSuccess,
    getEntityNameListFailure,
    clearEntityNameListResponse,
    postVideoDataSuccess,
    postVideoDataFailure,
    clearPostVideoDataResponse,
    putVideoDataSuccess,
    putVideoDataFailure,
    clearPutVideoDataResponse,
    putVideoKeywordMappingSuccess,
    putVideoKeywordMappingFailure,
    clearPutVideoKeywordMappingResponse,
    getVideoDetailLoading,
    getVideoDetailSuccess,
    getVideoDetailFailure,
    clearVideoDetailResponse,
    getVideoKeywordMappingLoading,
    getVideoKeywordMappingSuccess,
    getVideoKeywordMappingFailure,
    clearVideoKeywordMappingResponse,
    clearAllVideogResponses,
    getVideoTitleLoading,
    getVideoTitleSuccess,
    getVideoTitleFailure
} = videoSlice.actions;

// this action used in Video Overview or listing page
export const getMainCategoryList = (params) => {
    return async (dispatch) => {
        dispatch(getMainCategoryListLoading());
        await getMainCategoryRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getMainCategoryListSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getMainCategoryListFailure(error.message));
                }
            });
    };
};

export const getVideoListing = (params) => {
    return async (dispatch) => {
        dispatch(getVideoListingLoading());
        await getVideoListingRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getVideoListingSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getVideoListingFailure(error.message));
                }
            });
    };
};

export const getEntityTypeList = (params) => {
    return async (dispatch) => {
        dispatch(getEntityTypeLoading());
        await getEntityTypeRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getEntityTypeSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getEntityTypeFailure(error.message));
                }
            });
    };
};

// this action used in Video Save and Edit page
export const getMainCategoryDropDownData = (params) => {
    return async (dispatch) => {
        dispatch(getMainCategoryDropDownDataLoading());
        await getMainCategoryDropDownDataRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getMainCategoryDropDownDataSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getMainCategoryDropDownDataFailure(error.message));
                }
            });
    };
};

export const getSubCategoryList = (params) => {
    return async (dispatch) => {
        dispatch(getSubCategoryListLoading());
        await getSubCategoryListRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getSubCategoryListSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getSubCategoryListFailure(error.message));
                }
            });
    };
};

export const getEntityNameList = (params) => {
    return async (dispatch) => {
        dispatch(getEntityNameListLoading());
        await getEntityNameListRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getEntityNameListSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getEntityNameListFailure(error.message));
                }
            });
    };
};

export const postVideoDetail = (data) => {
    return async (dispatch) => {
        await postVideoDataRepo(data)
            .then((response) => {
                if (
                    response?.status == 200 ||
                    response?.status == 201 ||
                    response?.status == 302
                ) {
                    dispatch(postVideoDataSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postVideoDataFailure(error.message));
                }
            });
    };
};

export const putVideoDetail = (id, data) => {
    return async (dispatch) => {
        await putVideoDataRepo(id, data)
            .then((response) => {
                if (response && response?.status == 200 ||
                    response?.status == 201) {
                    dispatch(putVideoDataSuccess(response?.data?.data));
                } else {
                    dispatch({
                        payload: response && response.message,
                    });
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(putVideoDataFailure(error.message));
                }
            });
    };
};

export const putVideoKeywordMapping = (id, data) => {
    return async (dispatch) => {
        await putVideoKeywordMappingRepo(id, data)
            .then((response) => {
                if (response && response?.status == 200 ||
                    response?.status == 201) {
                    dispatch(putVideoKeywordMappingSuccess(response?.data?.data));
                } else {
                    dispatch({
                        payload: response && response.message,
                    });
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(putVideoKeywordMappingFailure(error.message));
                }
            });
    };
};

export const getVideoDetail = (id, params) => {
    return async (dispatch) => {
        dispatch(getVideoDetailLoading());
        await getVideoDetailRepo(id, params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getVideoDetailSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getVideoDetailFailure(error.message));
                }
            });
    };
};

export const getVideoKeywordMapping = (id, params) => {
    return async (dispatch) => {
        dispatch(getVideoKeywordMappingLoading());
        await getVideoKeywordMappingRepo(id, params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getVideoKeywordMappingSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getVideoKeywordMappingFailure(error.message));
                }
            });
    };
};

export const getVideoTitle = (params) => {
    return async (dispatch) => {
        dispatch(getVideoTitleLoading());
        await getVideoTitleRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getVideoTitleSuccess(response?.data?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getVideoTitleFailure(error.message));
                }
            });
    };
};
export default videoSlice.reducer;
